<template>
  <b-overlay :show="loading" id="management">
    <div
      v-if="!userSignConfiguration.userSigns.length && isSigner"
      class="text-center"
    >
      <h4 class="text-danger">
        * Este usuario no tiene configurada su firma electrónica *
      </h4>
    </div>
    <div class="row" v-if="fileOnFlow.detalle.ejecucion">
      <div class="col-1 position-relative text-center">
        <div v-if="fileOnFlowAttachments.length" class="container-attachment">
          <div
            v-for="attachment in orderedFiles"
            :key="attachment.url"
          >
            <vx-tooltip :text="`${attachment.nombreCompleto || attachment.nombre}`" position="right">
              <b-button
                v-if="attachment && !attachment.esInicial && attachment.firmado"
                variant="outline-success"
                class="btn-icon mt-2 text-center shadow"
                v-on:click="selectFile(attachment)"
                data-cy="signed-attachment"
              >
                <feather-icon icon="FileIcon"/>
              </b-button>
            </vx-tooltip>
            <vx-tooltip :text="`${attachment.nombreCompleto || attachment.nombre}`" position="right">
              <b-button
                v-if="attachment && !attachment.esInicial && !attachment.firmado"
                variant="outline-primary"
                class="btn-icon mt-2 text-center shadow"
                v-on:click="selectFile(attachment)"
                data-cy="attachment"
              >
                <feather-icon icon="FileIcon"/>
              </b-button>
            </vx-tooltip>
            <vx-tooltip :text="`${attachment.nombreCompleto || attachment.nombre}`" position="right">
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-warning"
                v-if="attachment && attachment.esInicial"
                class="btn-icon mt-2 text-center shadow"
                v-on:click="selectFile(attachment)"
                data-cy="main-attachment"
              >
                <feather-icon icon="FileTextIcon"/>
              </b-button>
            </vx-tooltip>
          </div>
          <div class="position-fixed manage-comments text-left m-auto">
            <div v-if="selectedSign.proveedor !== 'FirmadorMinisterioEconomia' && showSignButton">
              <h6 style="font-size: 12px;" class="my-2">
                Hey, estampa!!
              </h6>
              <b-button
                v-if="showSignButton"
                ref="signPosition"
                variant="warning"
                class="btn-icon rounded-circle shadow-lg sign-file"
                @click="setSign"
                data-cy="stamp"
              >
                <feather-icon icon="FeatherIcon"/>
              </b-button>
            </div>
            <div v-if="isOffice && !isReservedFile">
              <h6 style="font-size: 12px;" class="my-2 text-warning">
                privacidad
              </h6>
              <b-button
                @click="markFile()"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-warning"
                class="btn-icon rounded-circle shadow-lg"
                data-cy="btn-privacy"
              >
                <feather-icon icon="LockIcon"/>
              </b-button>
            </div>
            <div v-if="isOffice && participants.length">
              <h6 style="font-size: 12px;" class="my-2 text-primary">
                destinos
              </h6>
              <b-button
                v-b-modal="'modal-subjects'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-info"
                class="btn-icon rounded-circle shadow-lg"
                data-cy="btn-destinations"
              >
                <feather-icon icon="UsersIcon"/>
              </b-button>
              <Subjects/>
            </div>
            <div class="position-relative">
              <h6 style="font-size: 12px;" class="my-2">
                comentarios
              </h6>
              <span
                data-cy="comment-indicator"
                class="notification-indicator position-absolute"
                v-if="haveComments"
                style="z-index: 100;"
              >
                {{ haveComments }}
              </span>
              <b-button
                data-cy="bubble-comment"
                id="toggle-btn"
                v-b-modal="'modal-comments'"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="btn-icon rounded-circle shadow-lg"
              >
                <feather-icon icon="MessageCircleIcon"/>
              </b-button>
              <Comments
                v-if="fileOnFlow.detalle && fileOnFlow.detalle.ejecucion"
                :comments="fileOnFlow.detalle.ejecucion.comentarios"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-7">
        <a
          :class="{'d-none': isSiss && isReservedFile && isOffice}"
          :href="selectedFile.url"
          v-if="selectedFile" target="_blank"
        >
          <h5
            class="text-primary underline d-inline-block mr-2"
            data-cy="document-viewer"
          >
            * Visualizando documento seleccionado {{ selectedFile.nombreCompleto }}
            <small>({{ selectedFile.nombre }})</small> *
          </h5>
          <feather-icon icon="ExternalLinkIcon"/>
        </a>
        <div v-if="selectedFile" class="shadow bg-gray">
          <div v-if="fileType === 'pdf'" class="d-flex">
            <PdfViewport
              ref="pdfViewport"
              :hide-document="isSiss && isReservedFile && isOffice"
              :default-page="currentStepPage"
              :s3url="selectedFile.url"
              :name="selectedFile.nombreCompleto"
              :signatures="signatures"
              :signature-width="signatureWidth"
              :signature-height="signatureHeight"
              @loaded="setSign"
              @signature-drag-end="onSignatureDragEnd"
              @signature-delete="closeSign"
            />
          </div>
          <div v-if="fileType === 'image'">
            <b-img :src="selectedFile.url" fluid :alt="selectedFile.nombreCompleto"/>
          </div>
          <div v-if="fileType === 'docx'">
            <iframe
              :src="`https://portal.febos.cl/viewer/index.html?embedded=true&url=${encodeURIComponent(selectedFile.url)}`"
              width="100%"
              height="600px"
            />
          </div>
        </div>
      </div>
      <div class="col-4">
        <b-card class="shadow border-0 pt-0">
          <div class="bg-white pb-2">
            <h5 class="card-title mb-0" v-if="fileOnFlow.detalle && fileOnFlow.detalle.ejecucion">
              Expediente # {{ fileOnFlow.detalle.ejecucion.numero }} en el
              {{ fileOnFlow.detalle.ejecucion.nombre }}
            </h5>
            <div class="text-primary">
              {{ fileOnFlow.detalle.ejecucion.descripcion }}
            </div>
          </div>
          <b-card-body class="p-0">
            <div class="mt-2 shadow">
              <Steps
                v-if="fileOnFlow.detalle && fileOnFlow.detalle.pasos"
                :steps="fileOnFlow.detalle.pasos"
                :ejecucion="fileOnFlow.detalle.ejecucion"
              />
            </div>
            <div class="mt-5 container-actions" v-if="fileOnFlow.detalle">
              <ManageDocument
                :openConfigureSignModal="openConfigureSignModal"
                v-if="fileType === 'pdf' && fileLoaded && isConfigurator"
                :title="'Configurar firmas'"
                action="configure"
                @set-action="setAction"
                :newFlow="newFlow"
                color="outline-success"
                :step-id="step"
              />
              <ManageDocument
                v-has-permission="'ED242'"
                title="Editar"
                action="edit"
                @set-action="setAction"
                :newFlow="newFlow"
                v-if="isReviewer && isDocx && isEditable"
                :openManageFlowModal="openManageFlowModal"
                color="outline-warning"
                :step-id="step"
                :attachment="principalEditionFile"
              />
              <ManageDocument
                :openManageFlowModal="openManageFlowModal"
                v-if="!isSigner && !isConfigurator"
                :title="getApprovalRolTitle"
                action="approve"
                @set-action="setAction"
                :newFlow="newFlow"
                color="outline-success"
                :step-id="step"
              />
              <ManageDocument
                v-show="userSignConfiguration.userSigns.length"
                v-if="fileType === 'pdf' && showSignButton
                && !toProcessFile && canSign  && !isConfigurator"
                title="Firmar Adjunto"
                action="sign-attachment"
                data-cy="sign"
                @set-action="setAction"
                :newFlow="newFlow"
                color="outline-success"
                :step-id="step"
                :attachment="selectedFile"
                :get-sign="getPosition"
              />
              <ManageDocument
                :openManageFlowModal="openManageFlowModal"
                v-show="userSignConfiguration.userSigns.length"
                v-if="toProcessFile && isSigner && !isOffice  && !isConfigurator"
                title="Firmar"
                action="sign"
                @set-action="setAction"
                :newFlow="newFlow"
                color="outline-success"
                data-cy="sign"
                :step-id="step"
                :get-sign="getPosition"
                @selectedSign="selectedSign = $event"
              />
              <ManageDocument
                v-show="userSignConfiguration.userSigns.length"
                v-if="toProcessFile && isOffice && !isFileEDP  && !isConfigurator"
                :title="dynamicTitle"
                action="manage"
                color="outline-success"
                :process="isOffice"
                :step-id="step"
                :get-sign="getPosition"
              />
              <ManageDocument
                v-if="isFileEDP && toProcessFile && isOffice  && !isConfigurator"
                title="Entregar fecha"
                action="manage-date"
                color="outline-success"
                :step-id="step"
                :get-sign="getPosition"
              />
              <ManageDocument
                title="Rechazar"
                v-if="!isConfigurator"
                :openManageFlowModal="openManageFlowModal"
                action="reject"
                @set-action="setAction"
                :newFlow="newFlow"
                color="outline-danger"
                :step-id="step"
              />
              <ManageDocument
                title="Reenviar"
                action="resend"
                v-if="!isConfigurator"
                @set-action="setAction"
                :is-signer="isSigner"
                :has-signature-positon="hasSignaturePosition"
                :newFlow="newFlow"
                color="outline-info"
                :step-id="step"
              />
              <ManageDocument
                v-if="((canReturn && !haveExternStepProcessed) || (isOffice && !isGore))
                 && !isConfigurator"
                title="Devolver"
                action="return"
                color="outline-warning"
                :step-id="step"
              />
              <ManageDocument
                title="Comentar"
                action="comment"
                color="outline-secondary"
                :step-id="step"
                modal="comment"
                v-if="!isConfigurator"
              />
              <ManageDocument
                title="Adjuntar"
                action="attach"
                color="outline-secondary"
                :step-id="step"
                modal="comment"
                v-if="enableAttach && !isConfigurator"
              />
            </div>
          </b-card-body>
        </b-card>
      </div>
      <b-modal
        hide-header-close
        ok-only
        v-if="action && showModalConsequence &&
         consequenceType &&
         (processConsequence && Object.keys(processConsequence).length)"
        no-close-on-backdrop
        id="modal-consequence"
        ref="modal-consequence"
        title="Consecuencia del documento"
        data-cy="modal-consequence-document"
        ok-title="Aceptar"
        @ok="handleOk"
        size="xl"
      >
        <div v-if="!openManageFlowModal && showModalConsequence">
          <h3 v-if="consequenceType.nombre === 'gatilladorFlujo'">
            Redirigir flujo a un flujo predefinido
          </h3>
          <div v-if="processConsequence.configuracion.cambia_flujo
           && processConsequence.configuracion.cambia_flujo === 'si'">
            <h5>
              Por favor selecciona el flujo al que será reenviado
            </h5>
            <div>
              <v-select
                v-model="newFlow.aprobacionesReferenciaId"
                :options="filteredApprovalsTemplates"
                name="flow-select"
                label="nombre"
                data-cy="select-template"
                placeholder="Selecciona el flujo"
                :reduce="option => option.id"
              >
                <template slot="no-options">
                  no hay flujos
                </template>
              </v-select>
            </div>
            <hr>
          </div>
          <h3
            class="uk-modal-title" style="color: #e4501e;"
            v-if="consequenceType.nombre === 'gatilladorFlujoOnFly'"
          >
            Redirigir flujo a un flujo on the fly
          </h3>
          <div v-if="processConsequence.configuracion.seleccion_conductor == 'si'">
            <h5>Por favor, selecciona el archivo que será el principal para el flujo</h5>
            <div
              class="d-flex justify-content-between mt-2"
              v-for="attachment in fileOnFlowAttachments"
              :key="attachment.url"
            >
              <div>
                <strong>
                  <vs-icon
                    icon="description"
                    size="15px"
                    color="primary"
                  />
                </strong>
                <span v-if="attachment.nombreCompleto">{{ attachment.nombreCompleto }}</span>
                <span v-else>Adjunto</span>
                <span v-if="attachment.clasificacion">{{ attachment.clasificacion }}</span>
              </div>
              <b-button
                size="sm"
                variant="primary"
                @click="selectPrincipalAttachment(attachment)"
                v-if="!newFlow.documentos.length || (newFlow.documentos[0].url != attachment.url)"
              >
                seleccionar
              </b-button>
              <b-button
                size="sm"
                variant="success"
                v-if="newFlow.documentos.length && newFlow.documentos[0].url == attachment.url"
              >
                seleccionado
              </b-button>
            </div>
          </div>
          <hr v-if="processConsequence.configuracion.seleccion_conductor == 'si'">
          <div v-if="!onlyAttatchments.length">
            No hay documentos adjuntos para elegir
          </div>
          <div
            v-if="processConsequence.configuracion.adjuntos
             && processConsequence.configuracion.adjuntos == 'selecciona'
              && onlyAttatchments.length"
            class="wrap-content"
          >
            <h5>Por favor, selecciona los archivos que formarán parte del otro flujo</h5>
            <div
              class="row"
              v-for="attachmentFlow in newFlow.adjuntos"
              :key="attachmentFlow.url"
              style="border-bottom: 1px solid #c6ebfb;padding-bottom: 4px;"
            >
              <div class=" col-6 mt-3">
                <span class="">
                   <vs-icon
                     icon="description"
                     size="15px"
                     color="primary"
                   />
                  <span>
                    {{ !!attachmentFlow.nombreCompleto ? attachmentFlow.nombreCompleto : 'Adjunto' }}
                  </span>
                </span>
              </div>
              <div class="col-6 text-right mt-3">
                <b-button
                  size="sm"
                  variant="primary"
                  v-on:click="selectAttachment(attachmentFlow)"
                  v-if="!attachmentFlow.seleccionado"
                >
                  seleccionar
                </b-button>
                <b-button
                  size="sm"
                  variant="success"
                  v-on:click="removeAttachment(attachmentFlow)"
                  v-if="attachmentFlow.seleccionado"
                >
                  seleccionado
                </b-button>
              </div>
            </div>
          </div>
          <hr
            v-if="processConsequence.configuracion.adjuntos
             && processConsequence.configuracion.adjuntos == 'selecciona'"
          >
          <div v-if="consequenceType.nombre === 'gatilladorFlujoOnFly'">
            <div class="row">
              <div class="col-12">
                <h5>Configuración de pasos</h5>
                <table class="table text-center table-responsive" style="width: 100%">
                  <thead>
                  <tr>
                    <th class=" text-center">Tipo</th>
                    <th class=" text-center">Responsable</th>
                    <th class=" text-center">Rol</th>
                    <th class=" text-center"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="(responsable, index) in newFlow.pasos"
                    :key="`responsable-${index}`"
                    class="text-center"
                  >
                    <td>
                      <span v-if="stepTypesMixing.USER == responsable.tipoPasoId">Usuario</span>
                      <span v-if="stepTypesMixing.GROUP == responsable.tipoPasoId">Grupo</span>
                    </td>
                    <td>{{ responsable.nombre }}</td>
                    <td>
                      <span
                        v-if="rolTypesObject[responsable.rolId]"
                      >
                        {{ rolTypesObject[responsable.rolId] }}
                      </span>
                    </td>
                    <td>
                      <b-button
                        size="sm"
                        variant="danger"
                        @click="removeResponsible(index)"
                        v-tooltip="'Remover paso'"
                      >
                        <vs-icon
                          icon="delete"
                          size="15px"
                        />
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12 mt-2">
                <table
                  class="table text-center table-responsive"
                  style="width: 100%;border-top: 1px solid #a3a3a3;"
                >
                  <thead>
                  <tr>
                    <th class=" text-center">Tipo</th>
                    <th class=" text-center">Responsable</th>
                    <th class=" text-center">Rol</th>
                    <th class=" text-center"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      <vs-select
                        class="w-100"
                        autocomplete
                        label="Tipo de paso"
                        name="stepType"
                        v-model="newFlowStep.tipoPasoId"
                        :danger="errors.has('newFlowStep.stepType')"
                        :danger-text="errors.first('newFlowStep.stepType')"
                        v-validate="'required'"
                        ref="stepType"
                      >
                        <vs-select-item
                          value="1"
                          text="Grupo"
                        />
                        <vs-select-item
                          value="2"
                          text="Usuario"
                        />

                      </vs-select>
                    </td>
                    <td>
                      <list-groups
                        v-if="newFlowStep.tipoPasoId == stepTypesMixing.GROUP"
                        class="w-100"
                        autocomplete
                        label="Grupo del responsable"
                        name="groupStep"
                        ref="groupStep"
                        :typeList="newFlowStep.stepType"
                        v-model="newFlowStep.responsableId"
                        :danger="errors.has('newFlowStep.stepType')"
                        :danger-text="errors.first('newFlowStep.stepType')"
                        v-validate="{ required: newFlowStep.stepType === stepTypesMixing.GROUP }"
                      />
                      <list-user
                        v-if="newFlowStep.tipoPasoId == stepTypesMixing.USER"
                        class="w-100"
                        autocomplete
                        label="Responsable del paso"
                        name="userStep"
                        v-model="newFlowStep.responsableId"
                        ref="userStep"
                        :danger="errors.has('newFlowStep.responsableId')"
                        :danger-text="errors.first('newFlowStep.responsableId')"
                        v-validate="{ required: newFlowStep.stepType === stepTypesMixing.USER }"
                      />
                    </td>
                    <td>
                      <vs-select
                        class="w-100"
                        autocomplete
                        label="Tipo de paso"
                        name="stepType"
                        v-model="newFlowStep.rolId"
                        :danger="errors.has('newFlowStep.rolId')"
                        :danger-text="errors.first('newFlowStep.rolId')"
                        v-validate="'required'"
                        ref="stepType"
                      >
                        <vs-select-item
                          v-for="type in rolTypesAvalaibles"
                          :key="type.opcionId"
                          :value="type.valor"
                          :text="type.descripcion"
                        />
                      </vs-select>
                    </td>
                    <td style="text-align: center;">
                      <b-button
                        variant="success"
                        size="sm"
                        @click="addStepOnFly(newFlowStep)"
                      >
                        Agregar
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-if="errorConsequence" class="error-message mt-3 text-danger text-right">
            <span>
              {{ errorConsequence }}
            </span>
          </div>
        </div>
      </b-modal>
    </div>
  </b-overlay>
</template>
<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import Ripple from 'vue-ripple-directive';
import { BButton, BModal, VBTooltip } from 'bootstrap-vue';
import { uuid } from 'vue-uuid';

import Base64Mixin from '@/febos/global/_vue/mixins/Base64Mixin';
import ManageDocument from '@/febos/chile/approvals/components/trays/managementTray/ManageDocument';
import Steps from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Steps';
import Comments from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Comments';
import Subjects from '@/febos/chile/approvals/components/trays/managementTray/informationFlow/Subjects';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import { rolTypes, rolTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';
import PdfViewport from '@/febos/global/pdf/components/PdfViewport';
import { SIGNATURE_TYPES } from '@/febos/global/pdf/config';
import ApprovalActionsState from '@/febos/chile/dnt/mixins/ApprovalActionsState';
import { listOptions } from '@/febos/servicios/api/opciones.api';
import { isMicrosoftOfficeDocument } from '@/libs/webdav';
import ApprovalProcessStates from '@/febos/chile/approvals/mixins/ApprovalProcessStates';
import { clDntActFileED } from '@/febos/servicios/api/dnt.api';
import { makePrivateFlow } from '@/febos/servicios/api/aprobaciones.api';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ListUser from '@/febos/chile/lists/components/ListUser';

const SIGNATURE_WIDTH = 150;
const SIGNATURE_HEIGHT = 50;

export default {
  components: {
    ListUser,
    ListGroups,
    BButton,
    BModal,
    ManageDocument,
    Steps,
    Comments,
    Subjects,
    PdfViewport
  },
  mixins: [Base64Mixin],
  data() {
    return {
      fileLoaded: false,
      errorConsequence: '',
      error: {
        message: ''
      },
      comment: '',
      fileComment: {},
      commentFiles: [],
      newFlowProcessed: false,
      rolTypesObject: rolTypes,
      consequenceType: {},
      processConsequence: {},
      openManageFlowModal: false,
      openConfigureSignModal: false,
      showModalConsequence: false,
      newFlow: {
        aprobacionesReferenciaId: null,
        pasos: [],
        documentos: [],
        adjuntos: []
      },
      newFlowStep: {},
      action: '',
      redirectConsecuence: false,
      APR_GATILLACIONES: [
        {
          id: 'c6ec83a8-775a-11e9-aed6-1212502775ac',
          nombre: 'gatilladorFlujo'
        },
        {
          id: 'c6ec83a8-775a-11e9-aed6-1212502775a',
          nombre: 'gatilladorFlujo'
        },
        {
          id: 'c6ec83a8-775a-11e9-aed6-1212502775of',
          nombre: 'gatilladorFlujoOnFly'
        }
      ],
      APR_GATILLACIONES_TIPOS: {
        approve: 'POST_APROBADO',
        sign: 'POST_APROBADO',
        reject: 'POST_RECHAZO'
      },
      flowStates: ApprovalProcessStates,
      isPrincipalFile: false,
      fileType: undefined,
      signatures: [],
      stepTypesMixing: StepTypes,
      selectedFile: undefined,
      titleSign: 'Firmar',
      toProcessFile: false,
      showSignButton: false,
      selectedSign: {},
      signatureWidth: SIGNATURE_WIDTH,
      signatureHeight: SIGNATURE_HEIGHT,
      pdfSignatureAreas: {},
      hasPdfSignatures: false,
      signatureRelocationNotified: false
    };
  },
  watch: {
    'processConsequence.configuracion.aprobacion': {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.newFlow.aprobacionesReferenciaId = newValue;
        }
      }
    },
    'newFlow.documentos': {
      immediate: true,
      handler(newValue) {
        if (this.newFlow.documentos.length) {
          this.newFlow.adjuntos = [...this.newFlow.adjuntos].filter((file) => file.url !== this.newFlow.documentos[0].url);
        }
      }
    },
    /* loading(value) {
      if (!value) {
        console.log('loading', value);
        this.$vs.loading.close('#management > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#management',
        scale: 0.6
      });
    } */
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  computed: {
    ...mapGetters('Dnts', [
      'detailsFile',
      'participants'
    ]),
    ...mapGetters('Empresas', [
      'userSignConfiguration',
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Approvals', [
      'loading',
      'fileOnFlow',
      'fileOnFlowAttachments',
      'approvalsTemplates',
      'stepTypes',
      'stepRoles',
    ]),
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    isGore() {
      return this.company.iut === '72235100-2';
    },
    urlFile() {
      const { flowId } = this.$route.params;
      return `febos-io/global/${process.env.VUE_APP_AMBIENTE}/empresas/aprobaciones/${flowId}/comentarios`;
    },
    rolTypesAvalaibles() {
      const stepType = this.actualStepType;
      if (stepType && stepType.tipoRol && stepType.tipoRol.length > 0) {
        const avalaiblesTipesId = stepType.tipoRol;
        return this.stepRoles.filter((item) => avalaiblesTipesId.includes(item.valor));
      }
      return this.stepRoles;
    },
    stepTypesAvalaibles() {
      return this.stepTypes.filter((item) => item.plantilla);
    },
    filteredApprovalsTemplates() {
      return this.approvalsTemplates;
    },
    isReservedFile() {
      const RESERVED = '2';
      return this.detailsFile.dnt && this.detailsFile.dnt.transportePuertoTipo === RESERVED;
    },
    enableAttach() {
      return !this.isSiss;
    },
    getApprovalRolTitle() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion } = detalle;
      const actualStep = pasos
        .filter((step) => (
          step.id === ejecucion.pasoActualId
        )) || [];
      if (actualStep[0].paso.aprobacionesTipoRolId === rolTypesCode.visador) {
        return 'Visar';
      }
      return 'Aprobar';
    },
    canSign() {
      return this.userSignConfiguration.userSigns.length;
    },
    isOffice() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion } = detalle;
      return pasos
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && ((step.paso.aprobacionesTipoPasoId === this.stepTypesMixing.OFFICE.toString())
            || (step.paso.aprobacionesTipoPasoId === this.stepTypesMixing.OFFICER.toString()))
        ));
    },
    currentStep() {
      const {
        detalle: {
          pasos = [],
          ejecucion
        } = {}
      } = this.fileOnFlow;
      return pasos
        .find((step) => (
          step.id === ejecucion.pasoActualId
        ));
    },
    currentStepPage() {
      return this.toProcessFile ? this.currentStep.pagina || 1 : 1;
    },
    hasSignaturePosition() {
      return (
        this.toProcessFile
        && ((this.currentStep.x && this.currentStep.x !== '')
          && (this.currentStep.y && this.currentStep.y !== '')
          && (this.currentStep.pagina && this.currentStep.pagina !== ''))
      );
    },
    isSigner() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion } = detalle;
      return pasos
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && step.paso.aprobacionesTipoRolId === rolTypesCode.firmante
        ));
    },
    isConfigurator() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion } = detalle;
      return pasos
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && step.paso.aprobacionesTipoRolId === rolTypesCode.configurator
        ));
    },
    isReviewer() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion } = detalle;
      return pasos
        .some((step) => (
          step.id === ejecucion.pasoActualId
          && step.paso.aprobacionesTipoRolId === rolTypesCode.revisor
        ));
    },
    isDocx() {
      return this.selectedFile && isMicrosoftOfficeDocument(this.selectedFile.nombreCompleto);
    },
    isEditable() {
      return this.selectedFile.esInicial;
    },
    principalEditionFile() {
      return this.fileOnFlow.detalle.documentosBase[0];
    },
    step() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion } = detalle;
      return this.fileOnFlow.detalle && pasos.find((step) => step.id === ejecucion.pasoActualId);
    },
    haveExternStepProcessed() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [] } = detalle;

      const haveExternalStep = pasos.some(
        (step) => step.paso.aprobacionesTipoPasoId === this.stepTypesMixing.EXTERNAL
          && step.step.aprobacionesPasoEstadoId === this.flowStates.APPROVED
      );
      return haveExternalStep;
    },
    canReturn() {
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion = {} } = detalle;
      const { reversible } = ejecucion;
      const actualStep = pasos.find((step) => step.id === ejecucion.pasoActualId);
      if (!actualStep) return false;
      const isTemporal = actualStep.esTemporal;
      return actualStep.numeroPaso.toString() !== '1' && reversible && !isTemporal;
    },
    isFileEDP() {
      const { detalle = {} } = this.fileOnFlow;
      const { ejecucion = {} } = detalle;
      return ejecucion.tipoReferencia === 'ARCHIVO' && ejecucion.tipoObjetoCategoria === 'EDP';
    },
    dynamicTitle() {
      let isNumeration = false;
      if (this.fileOnFlow.meta) {
        isNumeration = Object.keys(this.fileOnFlow.meta.oficinaAcciones).includes('foliar');
      } else {
        isNumeration = true;
      }
      let returnTitle = isNumeration ? 'Numerar' : 'Tramitar';
      if (this.isFileEDP) {
        returnTitle = 'Fechar';
      }
      return returnTitle;
    },
    haveComments() {
      return this.fileOnFlow.detalle.ejecucion.comentarios
        .filter((comment) => comment.seguimientoId).length;
    },
    isLastStep() {
      return !this.fileOnFlow?.detalle?.ejecucion?.pasoSiguienteId;
    },
    onlyAttatchments() {
      return this.fileOnFlowAttachments.filter((file) => !file.esInicial);
    },
    orderedFiles() {
      const iniciales = this.fileOnFlowAttachments.filter((f) => f.esInicial);
      const noIniciales = this.fileOnFlowAttachments.filter((f) => !f.esInicial)
        .sort((a, b) => {
          if (!a.fecha) return 1;
          if (!b.fecha) return -1;
          return new Date(a.fecha) - new Date(b.fecha);
        });
      return [...iniciales, ...noIniciales];
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'getApprovalFileDetails',
      'getAttachmentFiles',
      'getApprovalsTemplates',
      'getStepTypes',
      'getStepRoles'
    ]),
    ...mapActions('Dnts', [
      'getFileDnt',
      'setDocumentInfo'
    ]),
    ...mapActions('Management', [
      'fetchAllDocuments'
    ]),
    markFile() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Heey!',
        text: '¿Estás seguro de marcar como reservado este documento?, esta acción no es reversible.',
        cancelText: 'Cancelar',
        acceptText: 'Confirmar',
        accept: () => this.confirmMarkFile()
      });
    },
    async confirmMarkFile() {
      const RESERVED = '2';
      await clDntActFileED({
        febosId: this.detailsFile.dnt.febosId,
        transportePuertoTipo: RESERVED
      });
      await this.$vs.notify({
        title: 'Genial!',
        text: 'Se ha marcado como reservado este documento.',
        color: 'success',
        time: 5000,
        position: 'top-center'
      });
      const { flowId } = this.$route.params;
      await makePrivateFlow(flowId, { privado: 'Y' });
      await this.getFileDnt({
        febosId: this.detailsFile.dnt.febosId,
        destinatarios: 'si',
        retornarDnt: 'si'
      });
    },
    closeSign() {
      this.signatures = [];
    },
    async fetchPdfSignatureAreas(pageNumber) {
      if (!this.$refs.pdfViewport
        || typeof this.$refs.pdfViewport.getSignatureAnnotations !== 'function'
      ) {
        return [];
      }

      const page = pageNumber || this.$refs.pdfViewport.getPageNumber() || 1;
      if (this.pdfSignatureAreas[page]) {
        return this.pdfSignatureAreas[page];
      }

      try {
        const annotations = await this.$refs.pdfViewport.getSignatureAnnotations(page);
        this.$set(this.pdfSignatureAreas, page, annotations);
        if (annotations.length) {
          this.hasPdfSignatures = true;
        }
        return annotations;
      } catch (error) {
        console.error('Error fetching PDF signatures', error);
        return [];
      }
    },
    rectanglesOverlap(position, area) {
      return (
        position.x < area.x + area.width
        && position.x + this.signatureWidth > area.x
        && position.y < area.y + area.height
        && position.y + this.signatureHeight > area.y
      );
    },
    async normalizeSignaturePosition(position) {
      if (!this.$refs.pdfViewport
        || typeof this.$refs.pdfViewport.getSignatureAnnotations !== 'function'
      ) {
        return position;
      }

      const targetPage = position.page || this.$refs.pdfViewport.getPageNumber() || 1;
      const annotations = await this.fetchPdfSignatureAreas(targetPage);

      if (!annotations.length) {
        return {
          ...position,
          page: targetPage
        };
      }

      const pageWidth = this.$refs.pdfViewport.getPageWidth() || (this.signatureWidth * 2);
      const pageHeight = this.$refs.pdfViewport.getPageHeight() || (this.signatureHeight * 2);
      const margin = 8;
      const limitX = Math.max(pageWidth - this.signatureWidth, 0);
      const limitY = Math.max(pageHeight - this.signatureHeight, 0);
      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const safeX = Number.isFinite(position.x) ? position.x : 0;
      const safeY = Number.isFinite(position.y) ? position.y : 0;

      const candidate = {
        ...position,
        page: targetPage,
        x: clamp(safeX, 0, limitX),
        y: clamp(safeY, 0, limitY)
      };

      const hasOverlap = (pos) => annotations.some((area) => this.rectanglesOverlap(pos, area));

      if (!hasOverlap(candidate)) {
        return candidate;
      }

      const overlappingAreas = annotations.filter(
        (area) => this.rectanglesOverlap(candidate, area)
      );
      const lateralPositions = [];

      overlappingAreas.forEach((area) => {
        lateralPositions.push({
          ...candidate,
          x: area.x + area.width + margin
        });
        lateralPositions.push({
          ...candidate,
          x: area.x - this.signatureWidth - margin
        });
      });

      for (let index = 0; index < lateralPositions.length; index += 1) {
        const lateralOption = lateralPositions[index];
        const adjustedLateral = {
          ...lateralOption,
          x: clamp(lateralOption.x, 0, limitX)
        };

        if (!hasOverlap(adjustedLateral)) {
          this.notifySignatureRelocation();
          return adjustedLateral;
        }
      }

      const candidates = [];
      const horizontalStep = this.signatureWidth + margin;
      const verticalStep = this.signatureHeight + margin;

      for (let posY = margin; posY <= limitY; posY += verticalStep) {
        for (let posX = margin; posX <= limitX; posX += horizontalStep) {
          candidates.push({ x: posX, y: posY });
        }
      }

      candidates.sort((a, b) => (
        Math.abs(a.x - candidate.x) + Math.abs(a.y - candidate.y)
        - (Math.abs(b.x - candidate.x) + Math.abs(b.y - candidate.y))
      ));

      for (let index = 0; index < candidates.length; index += 1) {
        const option = {
          ...candidate,
          x: candidates[index].x,
          y: candidates[index].y
        };
        if (!hasOverlap(option)) {
          this.notifySignatureRelocation();
          return option;
        }
      }

      this.$bvToast.toast(
        'No encontramos un espacio disponible para ubicar la firma sin superponer otra existente. Ajusta la posición manualmente.',
        {
          title: 'Atención',
          variant: 'warning',
          solid: true,
          autoHideDelay: 6000,
          toaster: 'b-toaster-top-center'
        }
      );

      return candidate;
    },
    notifySignatureRelocation() {
      if (this.signatureRelocationNotified) {
        return;
      }
      this.signatureRelocationNotified = true;
      this.$bvToast.toast(
        'Reubicamos la estampa para no cubrir una firma existente.',
        {
          title: 'Listo',
          variant: 'info',
          solid: true,
          autoHideDelay: 5000,
          toaster: 'b-toaster-top-center'
        }
      );
    },
    async setSign() {
      this.fileLoaded = true;
      if (!this.canSign) {
        return;
      }

      if (!this.isSigner && this.toProcessFile) {
        return;
      }
      const isExtraAction = this.dynamicTitle === 'Tramitar' && this.isOffice;
      if ((this.hasSignaturePosition && !isExtraAction)
        || (this.isGore && this.hasSignaturePosition)) {
        const {
          x,
          y,
          pagina: page
        } = this.currentStep;
        const signatureId = uuid.v4();
        const adjustedPosition = await this.normalizeSignaturePosition({ x, y, page });
        this.signatures = [{
          signatureId,
          x: adjustedPosition.x,
          y: adjustedPosition.y,
          page: adjustedPosition.page,
          type: this.isOffice ? SIGNATURE_TYPES.OfficeSignature : SIGNATURE_TYPES.UserSignature,
          ...(this.isOffice && {
            meta: {
              processType: this.dynamicTitle.toLowerCase()
            }
          })
        }];
        return;
      }

      if (this.isOffice && this.toProcessFile) {
        if (this.dynamicTitle === 'Numerar' || this.dynamicTitle === 'Fechar') {
          const pageNumber = this.$refs.pdfViewport.getPageNumber();
          const pageWidth = this.$refs.pdfViewport.getPageWidth();
          const signatureId = uuid.v4();
          const adjustedPosition = await this.normalizeSignaturePosition({
            x: pageWidth - 250,
            y: 20,
            page: pageNumber
          });
          this.signatures = [{
            signatureId,
            x: adjustedPosition.x,
            y: adjustedPosition.y,
            page: adjustedPosition.page,
            type: SIGNATURE_TYPES.DraggableOfficeSignature,
            meta: {
              processType: this.dynamicTitle.toLowerCase()
            }
          }];
          return;
        }

        if (this.dynamicTitle === 'Tramitar') {
          const pageNumber = this.$refs.pdfViewport.getPageNumber();
          const pageWidth = this.$refs.pdfViewport.getPageWidth();
          const pageHeight = this.$refs.pdfViewport.getPageHeight();
          const signatureId = uuid.v4();
          const adjustedPosition = await this.normalizeSignaturePosition({
            x: pageWidth - 250,
            y: pageHeight - 70,
            page: pageNumber
          });
          this.signatures = [{
            signatureId,
            x: adjustedPosition.x,
            y: adjustedPosition.y,
            page: adjustedPosition.page,
            type: SIGNATURE_TYPES.DraggableOfficeSignature,
            meta: {
              processType: this.dynamicTitle.toLowerCase()
            }
          }];
          return;
        }
      }

      const pageNumber = this.$refs.pdfViewport.getPageNumber();
      const pageHeight = this.$refs.pdfViewport.getPageHeight();
      const signatureId = uuid.v4();
      const adjustedPosition = await this.normalizeSignaturePosition({
        x: 20,
        y: pageHeight - 70,
        page: pageNumber
      });
      this.signatures = [{
        signatureId,
        x: adjustedPosition.x,
        y: adjustedPosition.y,
        page: adjustedPosition.page,
        type: SIGNATURE_TYPES.DraggableUserSignature
      }];

      if (this.fileOnFlow.acciones?.length > 0) {
        this.fileOnFlow.acciones
          .filter(
            (action) => action.estado === ApprovalActionsState.CREATED
              && (action.pagina && action.pagina > 0)
          ).forEach((action) => {
            const signatureActionId = uuid.v4();
            this.signatures.push({
              signatureId: signatureActionId,
              x: action.x,
              y: action.y,
              page: action.pagina,
              type: SIGNATURE_TYPES.OfficeSignature,
              isAction: true,
              meta: {
                processType: action.accion.toLowerCase()
              }
            });
          });
      }
    },
    getPosition() {
      const [signature] = this.signatures.filter(
        (signatureItem) => !signatureItem.isAction
      );
      if (!signature) {
        return {};
      }

      const {
        x,
        y,
        page
      } = signature;

      return {
        x,
        y,
        page
      };
    },
    selectFile(file) {
      this.signatures = [];
      this.selectedFile = undefined;
      this.fileType = undefined;
      this.pdfSignatureAreas = {};
      this.hasPdfSignatures = false;
      this.signatureRelocationNotified = false;

      if (file && (file.url.toLowerCase().includes('png')
        || file.url.toLowerCase().includes('jpg')
        || file.url.toLowerCase().includes('jpeg'))
      ) {
        this.fileType = 'image';
        this.selectedFile = file;
        return;
      }
      if (file && file.url.toLowerCase().includes('pdf')) {
        this.fileType = 'pdf';
        this.selectedFile = file;

        this.showSignButton = ((file.esInicial && this.isSigner) || file.id);
        this.toProcessFile = file.esInicial;
        return;
      }

      if (file && isMicrosoftOfficeDocument(file.url)) {
        this.fileType = 'docx';
        this.selectedFile = file;

        this.showSignButton = ((file.esInicial && this.isSigner) || file.id);
        this.toProcessFile = file.esInicial;
        return;
      }

      this.$bvToast.toast(
        'Este tipo de archivo no puede ser visualizado',
        {
          title: '¡Oops!',
          variant: 'warning',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      window.open(file.url, '_blank');
    },
    onSignatureDragEnd({ x, y }, signatureDraged) {
      const [signature] = this.signatures.filter(
        (signatureItem) => signatureItem.signatureId === signatureDraged.signatureId
      );
      this.signatures = [
        {
          ...signature,
          x,
          y
        }, ...this.signatures.filter(
          (signatureItem) => signatureItem.signatureId !== signatureDraged.signatureId
        )
      ];
    },
    // FUNCIONES DEL MODAL CONSECUENCIAS - PROCESAR FLUJO
    // FUNCIONES DEL MODAL CONSECUENCIAS
    removeResponsible(index) {
      this.newFlow.pasos.splice(index, 1);
      this.errorConsequence = '';
    },
    addStepOnFly(step) {
      if (!this.newFlowStep.tipoPasoId || !this.newFlowStep.responsableId || !this.newFlowStep.rolId) {
        return;
      }
      if (this.newFlowStep.tipoPasoId == this.stepTypesMixing.USER) {
        this.newFlowStep.nombre = this.$refs.userStep.getOption() && this.$refs.userStep.getOption().label;
      } else {
        this.newFlowStep.nombre = this.$refs.groupStep.getOption() && this.$refs.groupStep.getOption().label;
      }
      this.newFlow.pasos.push({
        tipoPasoId: this.newFlowStep.tipoPasoId,
        responsableId: this.newFlowStep.responsableId,
        rolId: this.newFlowStep.rolId,
        nombre: this.newFlowStep.nombre
      });
      this.newFlowStep = {
        tipoPasoId: '',
        responsableId: '',
        rolId: '',
      };
    },
    async configConsequence() {
      this.consequenceType = this.APR_GATILLACIONES.find((proceso) => proceso.id === this.processConsequence.aprobacionesGatilladorProcesoId);

      this.redirectConsecuence = true;

      if (this.processConsequence.configuracion.adjuntos && this.processConsequence.configuracion.adjuntos === 'selecciona') {
        this.newFlow.adjuntos = this.fileOnFlowAttachments
          .filter((file) => !file.esInicial)
          .map((item) => ({ ...item, seleccionado: false }));
      } else if (this.processConsequence.configuracion.seleccion_conductor == 'no') {
        this.newFlow.adjuntos = this.fileOnFlowAttachments.map((item) => ({ ...item, seleccionado: false }));
      }

      if (this.consequenceType.nombre === 'gatilladorFlujoOnFly') {
        this.newFlow.pasos = [...this.processConsequence.configuracion.pasos] || [];
        this.newFlowStep = {};
      }

      if (
        this.consequenceType.nombre === 'gatilladorFlujo'
        && this.processConsequence.configuracion.cambia_flujo
        && this.processConsequence.configuracion.cambia_flujo === 'si'
      ) {
        let tipoReferencia = this.fileOnFlow.detalle.documentosBase[0].tipoObjetoId;
        if (tipoReferencia.includes('-')) {
          tipoReferencia = tipoReferencia.split('-')[0];
        }
        await this.getApprovalsTemplates({
          params: {
            filtros: `iutEmpresa:${this.company.id}|aprobacionesEstado:Y|filtrarUnidad:Y|tipoObjeto:${tipoReferencia}`,
            pagina: 1,
            orden: '-fechaCreacion',
            itemsPorPagina: 2000
          }
        });
      }
      this.showModalConsequence = true;
      if (this.action && this.showModalConsequence) {
        setTimeout(() => {
          this.$refs['modal-consequence'].show();
        }, 1000); // Pequeña espera para que Vue lo monte
      }
    },
    selectPrincipalAttachment(attachment) {
      // this.newFlow.adjuntos = [attachment, ...this.newFlow.adjuntos.filter(item => item.url !== attachment.url)];
      Vue.set(this.newFlow.documentos, 0, attachment);
      this.newFlow.adjuntos = [...this.fileOnFlowAttachments].filter((file) => file.url !== this.newFlow.documentos[0].url);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
      this.errorConsequence = '';
    },
    selectAttachment(attachment) {
      this.newFlow.adjuntos.forEach((item, index) => {
        if (item.url === attachment.url) {
          Vue.set(this.newFlow.adjuntos, index, { ...item, seleccionado: true });
        }
      });
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    removeAttachment(attachment) {
      this.newFlow.adjuntos = [...this.newFlow.adjuntos]
        .map((item) => (item.url === attachment.url ? { ...item, seleccionado: false } : item));
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
    handleOk(bvModalEvt) {
      if (this.consequenceType.nombre === 'gatilladorFlujoOnFly') {
        if (!this.newFlow.pasos.length) {
          this.errorConsequence = 'Por favor, ingresa al menos un paso para el flujo';
          bvModalEvt.preventDefault();
          return;
        }
        if (this.newFlow.pasos && (this.newFlow.pasos[this.newFlow.pasos.length - 1] || {}).rolId == rolTypesCode.revisor) {
          this.errorConsequence = 'El último paso del flujo no puede ser revisor';
          bvModalEvt.preventDefault();
          return;
        }
      }

      if (this.processConsequence.configuracion.seleccion_conductor == 'si'
        && !this.newFlow.documentos.length) {
        this.errorConsequence = 'Por favor, selecciona el archivo principal';
        bvModalEvt.preventDefault();
        return;
      }

      if (this.processConsequence.configuracion.adjuntos == 'selecciona'
        && this.newFlow.adjuntos && this.onlyAttatchments.length) {
        const adjuntosSeleccionados = this.newFlow.adjuntos.some((file) => file.seleccionado);
        if (!adjuntosSeleccionados) {
          this.errorConsequence = 'Por favor, selecciona al menos un archivo como adjunto';
          bvModalEvt.preventDefault();
          return;
        }
      }

      if (this.consequenceType.nombre === 'gatilladorFlujo') {
        if (!this.newFlow.aprobacionesReferenciaId) {
          this.errorConsequence = 'Por favor, selecciona el flujo';
          bvModalEvt.preventDefault();
          return;
        }
      }
      this.newFlow = {
        ...this.newFlow,
        processConsequence: this.processConsequence,
        consequenceType: this.consequenceType,
        currentStep: this.currentStep
      };
      this.showModalConsequence = false;
      this.openManageFlowModal = true;
      this.newFlowProcessed = true;
    },
    searchConsequences() {
      const { detalle = {} } = this.fileOnFlow;
      const { baseGatillaciones = [] } = detalle;

      const accionProceso = this.action;
      const gatillacionTipo = this.APR_GATILLACIONES_TIPOS[accionProceso];
      return baseGatillaciones.find((gatillacion) => gatillacion.estado === gatillacionTipo && gatillacion.requiereAccion === 'Y');
    },
    setAction(action) {
      this.action = action;
      this.errorConsequence = '';
      if (this.newFlowProcessed) {
        console.log('procesado, se puede abrir el otro modal');
        return;
      }
      const { detalle = {} } = this.fileOnFlow;
      const { pasos = [], ejecucion = {} } = detalle;
      const actualStep = pasos.find((step) => step.id === ejecucion.pasoActualId);
      const isTemporal = actualStep.esTemporal;
      const flujoSigue = actualStep.temporalContinuaFlujo;
      const reenvioSigue = isTemporal && flujoSigue;
      const reenvioVuelve = isTemporal && !flujoSigue;
      // valida que no sea un paso temporal - ya que se puede reenviar antes de terminar el flujo

      if (this.fileOnFlow && this.fileOnFlow.detalle
        && this.fileOnFlow.detalle.ejecucion && this.isLastStep && (!isTemporal || reenvioSigue)) {
        const consequence = this.searchConsequences();
        if (consequence) {
          this.processConsequence = {
            ...consequence,
            configuracion: JSON.parse(this.decode(consequence.configuracion))
          };
          if (this.processConsequence) {
            this.configConsequence();
            this.openManageFlowModal = false;
          } else {
            this.openManageFlowModal = true;
          }
        }
      }
    },
  },
  async created() {
    const { fileId } = this.$route.params;
    const { flowId } = this.$route.params;
    try {
      this.$bvToast.toast(
        'Estamos buscando la información necesaria, espera unos segundos',
        {
          title: '¡Hola!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          autoHideDelay: 4000,
        }
      );
      await Promise.all([
        this.getApprovalFileDetails({
          aprobacionId: fileId,
          ejecucionId: flowId,
          retornarPdf: 'no'
        }),
        this.getAttachmentFiles({
          aprobacionId: fileId,
          ejecucionId: flowId
        })
      ]);
      this.selectFile(this.fileOnFlowAttachments[0]);
      await this.fetchAllDocuments();
      if (this.fileOnFlow.detalle.documentosBase[0].tipoObjetoId === 'EXP') {
        await this.setDocumentInfo({});
        await this.getFileDnt({
          febosId: this.fileOnFlow.detalle.documentosBase[0].objetoId,
          destinatarios: 'si',
          retornarDnt: 'si'
        });
        const { data: { opciones } } = await listOptions({
          grupoOpcion: 'tipos.documentos-ed',
          deshabilitado: 'no',
          agrupar: 'si'
        });
        if (
          this.detailsFile.dnt.emisorCentroCostoNumero
          || this.detailsFile.dnt.emisorSucursalPais
        ) {
          const opcion = opciones.find(
            (item) => item.opcionId === this.detailsFile.dnt.emisorCentroCostoNumero
              || item.opcionId === this.detailsFile.dnt.emisorSucursalPais
          );
          if (opcion) {
            try {
              opcion.extra = JSON.parse(opcion.extra);
            } catch (e) {
              console.error('cant parse extra data', e);
            }
            await this.setDocumentInfo(opcion);
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
    await this.getStepTypes();
    await this.getStepRoles();
  },
  mounted() {

  },
};
</script>
<style>
.annotationLayer {
  position: absolute !important;
  border-bottom: 1px solid #c3c3c3;
}

.linkAnnotation {
  transform: unset !important;
  transform-origin: unset !important;
  left: unset !important;
  top: unset !important;
  right: 0 !important;
  bottom: 0 !important;
}

.selected {
  background-color: rgba(116, 74, 135, 0.49);
  border: 1px solid rgb(230 191 247);
}

.manage-comments {
  bottom: 60px;
}

.container-attachment {
  max-height: 55vh;
  overflow-y: scroll;

}

.container-actions {
  height: 350px;
  overflow-y: scroll;
}

.container-pdf {
  max-height: 85vh;
  overflow-y: auto;
}

.page {
  height: auto;
  margin: 0 auto;
}

.notification-indicator {
  background: red;
  color: white;
  padding: 3px 8px;
  border-radius: 50%;
  right: 50%;
  top: 15px;
}
</style>
